import { useState } from 'react';
import { useSelector } from 'react-redux';

import { mapStateToBadgeInfo } from 'modules/experiments/utils';
import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { getExperimentHeaderMetadata } from 'modules/experiments/ducks/selectors';

import { Badge } from 'ui/badge';

import { ExperimentDetailsContainer, BoldHoverUnderline, Detail, PrimaryDetail } from '../Styled';
import { CampaignPopover } from './CampaignPopover';

export const ExperimentDetails = () => {
  const { id, experimentState } = useSelector(getExperimentHeaderMetadata);
  const [showPopover, setShowPopover] = useState(false);
  // Translations
  const { t } = useExperimentsTranslations();

  // Experiment State
  const { variant, label } = mapStateToBadgeInfo(experimentState);

  return (
    <ExperimentDetailsContainer>
      <Detail>
        <Badge variant={variant}>{label}</Badge>
      </Detail>
      <PrimaryDetail>{`ID: ${id}`}</PrimaryDetail>
      <Detail>
        {`${t('monitor.header.campaignPrefix')} `}
        <BoldHoverUnderline
          data-test="experiment-campaign-info-popover"
          onClick={() => setShowPopover(true)}
          onBlur={() => setShowPopover(false)}
        >
          <CampaignPopover open={showPopover} />
        </BoldHoverUnderline>
      </Detail>
    </ExperimentDetailsContainer>
  );
};
